<template>
  <div>
    <b-modal
      id="viewResume"
      centered
      hide-footer
      hide-header
      size="lg"
      :visible="showModal"
      no-close-on-backdrop
      @hidden="closeModal"
    >
      <div class="d-flex">
        <div class="viewResume-left-modal-back"></div>
        <div class="w-94">
          <div class="viewResume-modal-header">
            <div>Preview {{ label }}</div>

            <div class="d-flex gap-15">
              <div
                v-if="from == 'onboardDoc'"
                class="
                  d-flex
                  justify-content-between
                  align-items-center
                  pointer
                  gap-5px
                "
                @click="downloadLink(link)"
              >
                <img
                  class="pointer"
                  height="15"
                  src="@/assets/newJD/newCand-download-icon.svg"
                  alt
                />
                <div class="download-blue-text">Download</div>
              </div>
              <img
                class="rotate-on-hover"
                src="../../assets/img/accessconnew/blueCross.svg"
                alt
                @click="closeModal"
              />
            </div>
          </div>
          <div
            v-if="getFileType()[0] == 'pdf'"
            class="d-flex flex-column align-items-center pt-2 pl-4 pr-4 pb-2"
          >
            <div class="viewResume-graph-overflow p-2">
              <div class="viewResume-Graph-modal-resume">
                <pdf
                  ref="pdf"
                  :src="link"
                  :page="currentPage"
                  @num-pages="numPages = $event"
                  @link-clicked="handlePageLoaded"
                  @page-loaded="handlePageLoaded"
                ></pdf>
              </div>
            </div>
            <div
              class="
                viewResume-paginaTion-modal
                align-items-center
                justify-content-center
                d-flex
                w-100
              "
            >
              <div class="pagination">
                <b-pagination
                  align="center"
                  v-model="currentPage"
                  :total-rows="numPages"
                  :per-page="perPage"
                  first-number
                  last-number
                >
                  <template #prev-text>
                    <span>
                      <img
                        src="../../assets/img/accessconnew/pageleft.svg"
                        alt
                      />
                    </span>
                  </template>
                  <template #next-text>
                    <span>
                      <img
                        src="../../assets/img/accessconnew/pageright.svg"
                        alt
                      />
                    </span>
                  </template>
                </b-pagination>
              </div>
            </div>
          </div>
          <div
            v-else
            class="
              p-2
              view-doc-main
              d-flex
              align-items-center
              justify-content-center
            "
          >
            <!-- :class="
              checkImage()
                ? 'modals-scroll'
            <div v-if="checkImage()">
              <img :src="link" style="width: 100%" alt />
            </div> -->
            <div class="ondoc-word-resume">
              <div class="text-center">
                <img :src="getFileType()[1]" alt />
              </div>
              <div class="mt-2 text-center">
                <div class="newCand-word-resume-font text-truncate">
                  {{ getFileNameFromLink(link) }}
                </div>
                <div class="slating-sub-text">
                  Download the document to view it
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import {
  getFileType,
  getFileNameFromLink,
} from "../../controllers/commonHelpers";

export default {
  name: "viewresume",
  data() {
    return {
      currentPage: 1,
      numPages: 0,
      perPage: 1,
    };
  },
  props: {
    link: String,
    showModal: Boolean,
    label: String,
    from: String,
  },
  components: {
    pdf,
  },
  methods: {
    downloadLink(link) {
      const a = document.createElement("a");
      a.href = link;
      a.click();
    },
    closeModal() {
      this.$emit("close-modal");
    },
    handlePageLoaded(pageNumber) {
      this.currentPage = pageNumber;
      const viewerElement = this.$refs.pdf.$el;
      if (viewerElement) {
        viewerElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    getFileType() {
      return getFileType(this.link);
    },
    getFileNameFromLink() {
      return getFileNameFromLink(this.link);
    },
    checkImage() {
      return ["jpg", "gif", "jpeg", "png"].includes(this.getFileType()[0]);
    },
  },
};
</script>

<style></style>
